'use client';
import { scaledRemCalc } from '@mnd-frontend/utils';
import styled from 'styled-components';
import {
  useEventContext,
  useHoveredContext,
  useOptionsContext,
  useSelectedContext,
} from '../../context';
import LegendIcon from './LegendIcon';

const LegendItemWrapper = styled.div<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  font-weight: ${props => props.$selected && 'bold'};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const LegendText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: ${scaledRemCalc(16)};
`;

const LegendItem = ({ id, name, value, color }: any) => {
  const { hideSelected } = useOptionsContext();
  const isHovered = useHoveredContext();
  const isSelected = useSelectedContext();
  const { handleMouseEnter, handleMouseLeave, handleClick } = useEventContext();

  return (
    <LegendItemWrapper
      $selected={!hideSelected && (isSelected(id) || isHovered(id))}
      onMouseEnter={event => handleMouseEnter(id, event)}
      onMouseLeave={event => handleMouseLeave(id, event)}
      onClick={event => handleClick(id, event)}
    >
      <LegendIcon color={color} $inactive={hideSelected && isSelected(id)} />
      <LegendText>
        {name}
        {value ? ` (${value})` : ''}
      </LegendText>
    </LegendItemWrapper>
  );
};

export default LegendItem;
